import React from 'react'
import { Form } from 'react-bootstrap';
import Autocomplete from "react-google-autocomplete";

const DropOffLocation = ({ onSave, defaultValue, error, field }) => {

    return (
        <>
            <Form.Group className="mb-3 flex-1" id="address1">
                <Form.Label>Location: <span className='text-danger'>*</span></Form.Label>
                <div className={`${error ? 'border border-danger' : ''}`}>
                    <Autocomplete
                        apiKey="AIzaSyAsh-ofw4XiKuvo4W1GOIutG7NpHLbp2Hw"
                        onPlaceSelected={(place) => {
                            onSave(place)
                        }}
                        options={{
                            types: ["geocode"], // Can be ['establishment', 'address', '(regions)']
                        }}
                        className="form-control custome_border_in border-0 border-bottom rounded-0 px-0 w-100"
                        defaultValue={defaultValue}
                        {...field}
                    />
                </div>
            </Form.Group>
        </>
    )
}

export default DropOffLocation